export default {
    namespaced: true,
    state:{
        //editor type can be 'wysiwyg' or 'DnD'
        editorType:'DnD',
        pageDetails:{
            name: '',
            pageUrl: '',
            publishAt: '',
            expireAt: '',
            publishAtTime: '',
            expireAtTime: '',
            pageTracking:''
        },
        cnameValidation:{
            isValid:true,
            message:''
        },
        templateFilter: '',
        jsonPart: null,
        htmlPart:null,
        loading: false
    },
    mutations:{
        savePageDetails:(state,details)=>{
            state.pageDetails = details
        },
        setEditorType:(state,editorType)=>{
            state.editorType = editorType
        },
        setTemplateFilter:(state,templateFilter)=>{
            state.templateFilter = templateFilter
        },
        setJsonPart:(state,jsonPart)=>{
            state.jsonPart = jsonPart
        },
        setHtmlPart:(state,htmlPart)=>{
            state.htmlPart = htmlPart
        },
        setLoading:(state,loading)=>{
            state.loading = loading
        },
        setCnameValidation:(state,cnameVal)=>{
            state.cnameValidation = cnameVal
        },
    },
    getters:{
        pageDetails:state=>state.pageDetails,
        editorType:state=>state.editorType,
        templateFilter:state=>state.templateFilter,
        jsonPart:state=>state.jsonPart,
        htmlPart:state=>state.htmlPart,
        loading:state=>state.loading,
        cnameValidation:state => state.cnameValidation
    }
}